import { propertyQueryKeys as e } from "../properties/usePropertiesQueryKeys.mjs";
import { recentlyViewedQueryKeys as t } from "./useRecentlyViewedQueryKeys.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { recentlyViewedApi as i } from "@maat/api-main";
//#region src/recentlyViewed/useRecordListingViewMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: (e) => i.record(e),
		retry: !1,
		onSuccess: () => {
			a.invalidateQueries({ queryKey: t.list() }), a.invalidateQueries({ queryKey: e.guestHomePersonal() });
		}
	});
};
//#endregion
export { a as useRecordListingViewMutation };
